import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { WarehouseFactory, WarehouseMapperParameter } from "@/v2/models/warehouses.js";
import { Parameter } from "@/v2/models/parameters.js";

export class Company extends DataObject {
    _type = "company";
    id;
    type;
    primary_user_id;
    supplier_code;
    name;
    phone;
    email;
    status;
    registration_number;
    code;
    warehouse_id;
    heineken_distributor_code;
    heineken_ucc;
    analysis_code;
    agency_code;
    debtor_code;
    debtor_branch_code;
    category;
    currency;
    remark;
    to_block;
    prepaid_credits;
    price_tags;
    price_tag_sources;
    rep_user_ids;
    payment;
    billing_address;
    shipping_addresses;
    attachments = [];
    user_meta;
    credit;
    credit_term_code;
    overdue_limit;
    tiers;
    representatives;
    primary_user = new User();
    mango_credit;
    warehouse;
    tax_exempted;
    currency_symbol;
    custom_fields = {};
    bo_can_delete;
    show_action_menu;
    representatives = {};
    payment_methods;
    customer_payment_methods;

    getAttachmentByKey(key) {
        const attachments = this.attachments.filter((attachment) => attachment.pivot.key === key);

        if (attachments) {
            return attachments[0];
        }

        return null;
    }

    // getCompanyFullAddress() {
    //     let fullAddress = [];
    //     fullAddress.push(this.billing_address.address_1 == "" ? null : this.billing_address.address_1);
    //     fullAddress.push(this.billing_address.address_2 == "" ? null : this.billing_address.address_2);
    //     fullAddress.push(this.billing_address.city == "" ? null : this.billing_address.city);
    //     fullAddress.push(this.billing_address.postcode == "" ? null : this.billing_address.postcode);
    //     fullAddress.push(this.billing_address.state == "" ? null : this.billing_address.state);

    //     fullAddress = fullAddress.filter((address) => {
    //         return address != null;
    //     });

    //     return fullAddress.join(", ") + ".";
    // }
}

export class CompanyMapperParameter extends Parameter {
    warehouseMapperParameter = new WarehouseMapperParameter();
    companyMapper;
    userMapper;
}

export class User extends DataObject {
    _type = "user";
    id;
    agent_code;
    agent_branch_code;
    email;
    email2;
    email_pending;
    phone;
    ic;
    passport;
    phone_pending;
    first_name;
    last_name;
    roles;
    capabilities;
    device_id;
    bo_can_delete;
    show_action_menu;
}

export class MangoCredit extends DataObject {
    id;
    retailer_id;
    available_limit;
    due_day;
    term_days;
    total_limit;
    on_hold_limit;
    provider;
    rate;
    should_add_user_term;
    virtual_account_number;
    company_registration_number;
    master_card_token;
    created_at;
    updated_at;
    deleted_at;
    bo_can_delete;
    show_action_menu;
}

export class CompanyFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {CompanyMapperParameter} companyMapperParameter Parameter object containing mappers that the factory expects.
     * @param {Object, null} data Data to construct the Company object with. Also creates a Meta object using MetaFactory if data is not null.
     * @returns {Company}
     */
    static construct(companyMapperParameter, data = null) {
        if (data != null) {
            let company = DataObjectFactory.getInstance().construct(
                Company,
                data ? companyMapperParameter.companyMapper(data) : null
            );

            // extract the "custom-{field}" elements from the data object
            const customFields = Object.keys(data)
                .filter((key) => key.startsWith("custom-"))
                .reduce((obj, key) => {
                    obj[key] = data[key];
                    return obj;
                }, {});

            // adding custom fields to the company object
            company = Object.assign(company, customFields);

            if (companyMapperParameter.userMapper != null) {
                let user = DataObjectFactory.getInstance().construct(
                    User,
                    data.primary_user ? companyMapperParameter.userMapper(data.primary_user) : null
                );
                company.primary_user = user;
            }

            if (data.warehouse != null) {
                let warehouse = WarehouseFactory.construct(
                    companyMapperParameter.warehouseMapperParameter,
                    data.warehouse
                );
                company.warehouse = warehouse;
            }

            if (data.tiers && data.tiers.length) {
                const tiers = [];
                data.tiers.forEach((tier) => {
                    tiers.push(tier);
                });
                company.tiers = tiers;
            } else {
                company.tiers = "";
            }

            if (data.mango_credit) {
                company.mango_credit = DataObjectFactory.getInstance().construct(MangoCredit, data.mango_credit);
            }

            return company;
        }
        return null;
    }
}
